import React, { useState, useEffect } from 'react';
import UsersTemplateStyle from './UsersTemplateStyle';
import Text from '../../atoms/Text/Text';
import HeaderText from '../../atoms/HeaderText/Text';
import Image from '../../atoms/Image/Img';
import nike from '../../../assets/images/nike.svg';
import Button from '../../atoms/Button/Button';
import Input from '../../atoms/Input/Input';
import exportIcon from '../../../assets/images/download-icon.svg';
import userIcon from '../../../assets/images/user-icon-white.svg';
import filterIcon from '../../../assets/images/filter-icon.svg';
import plus from '../../../assets/images/plus-icon.svg';
import UsersTable from '../../organisms/UsersTable/UsersTable';
import { useDispatch, useSelector } from 'react-redux';
import { TypedDispatch, RootStore } from '../../../config/ConfigStore';
import { DashboardActions } from '../../../redux/actions/DashboardAction';
import { exportAll, exportClear } from '../../../redux/actions/ExportAction';
import FetchLoading from '../../molecules/FetchLoading/FetchLoading';
import { CSVLink } from "react-csv";
import AddUserModal from '../../organisms/AddUserModal/AddUserModal';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { addDays, format } from 'date-fns';
import { DateRange, DayPicker } from 'react-day-picker';
import caret from '../../../assets/images/caret-filter-select.svg';
import SettingsNavBar from '../../organisms/SettingsNavBar/SettingsNavBar';

const pastMonth = new Date();

const UsersTemplate = () => {
  let timeOutId: any = null;
  const [selectedMenu, setSelectedMenu] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [reloadPage, setReloadPage] = useState(false);
  const [toggleAddUserModal, setToggleAddUserModal] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const dispatch: TypedDispatch = useDispatch();
  const state: any = useSelector((state: RootStore) => state);
  const [filterValues, setFilterValues] = useState<any>({});
  const [fields, setFields] = useState({
    dateRange: '',
    username: '',
    status: ''
  });

  const onClickHandler = (value: boolean) => {
    if (selectedMenu !== false) {
      setSelectedMenu(false);
      return;
    }
    setSelectedMenu(value);
  }

  const onBlurHandler = () => {
    timeOutId = setTimeout(() => {
      setSelectedMenu(false);
    });
  }

  const onFocusHandler = () => {
    clearTimeout(timeOutId);
  }

  useEffect(() => {
    dispatch(exportAll(`/users?size=0&page=1`));
  }, [])

  useEffect(() => {
    dispatch(exportClear());
    generatePageContent();
    console.log(state);
  }, [size, page, reloadPage])

  const generatePageContent = async () => {
    setFetchLoading(true);
    await dispatch(DashboardActions(`/users?size=${size}&page=${page}&firstName=${search.split(" ")[0]}&lastName=${search.split(" ")[1]}`));
    setFetchLoading(false);
  }

  const renderFetchLoading = () => {
    if (fetchLoading) {
      return (
        <FetchLoading />
      )
    }
  }

  const changePage = (value: number) => {
    setPage(value);
  }

  const changeSize = (value: number) => {
    setSize(value);
  }

  const exportData = () => {
    return {
      fileData: () => {
        let users = state.exportReducer.results.data.map((user: Record<any, any>) => {
          return (
            {
              Firstname: user.firstName,
              Lastname: user.lastName,
              Email: user.email,
              Phone: user.phoneNumber,
              DateCreated: dayjs(user.createdDate).format('MM/DD/YYYY'),
              LastActive: dayjs(user.lastLoginDate).format('MM/DD/YYYY'),
              Username: user.username
            }
          )
        })
        let data = [...users];
        return data
      },
      fileHeaders: () => {
        let headers = [
          { label: "Firstname", key: "Firstname" },
          { label: "Lastname", key: "Lastname" },
          { label: "Email", key: "Email" },
          { label: "Phone Number", key: "Phone" },
          { label: "Date Created", key: "DateCreated" },
          { label: "Last Active", key: "LastActive" },
          { label: "Username", key: "Username" },
        ];
        return headers;
      }
    }
  }

  const exportDataAll = () => {
    return {
      fileData: () => {
        let users = state.exportReducer.allResults.data.map((user: Record<any, any>) => {
          return (
            {
              Firstname: user.firstName,
              Lastname: user.lastName,
              Email: user.email,
              Phone: user.phoneNumber,
              DateCreated: dayjs(user.createdDate).format('MM/DD/YYYY'),
              LastActive: dayjs(user.lastLoginDate).format('MM/DD/YYYY'),
              Username: user.username
            }
          )
        })
        let data = [...users];
        return data
      },
      fileHeaders: () => {
        let headers = [
          { label: "Firstname", key: "Firstname" },
          { label: "Lastname", key: "Lastname" },
          { label: "Email", key: "Email" },
          { label: "Phone Number", key: "Phone" },
          { label: "Date Created", key: "DateCreated" },
          { label: "Last Active", key: "LastActive" },
          { label: "Username", key: "Username" },
        ];
        return headers;
      }
    }
  }

  const refreshTable = () => {
    if (reloadPage) {
      return setReloadPage(false);
    }
    setReloadPage(true);
  }

  const showAddUserModal = () => {
    setToggleAddUserModal(true);
  }

  const hideAddUserModal = () => {
    setToggleAddUserModal(false);
  }

  const renderAddUserModal = () => {
    if (toggleAddUserModal) {
      return (
        <AddUserModal handleClose={hideAddUserModal} reloadPage={refreshTable} />
      )
    }
  }

  const defaultSelected: DateRange = {
    from: pastMonth,
    to: addDays(pastMonth, 4)
  };
  const [range, setRange] = useState<DateRange | any>(defaultSelected);

  let footer = <p>Please pick the first day.</p>;
  if (range !== undefined && range.from) {
    if (!range.to) {
      footer = <p>{format(range.from, 'PPP')}</p>;
    } else if (range.to) {
      footer = (
        <p>
          {format(range.from, 'PPP')}–{format(range.to, 'PPP')}
        </p>
      );
    }
  }

  const changeFilterValue = async (event: any, name: string, value: string) => {
    if (event.target.checked) {
      const filterValuesObj: any = Object.assign({}, filterValues);
      filterValuesObj[name] = value;
      await setFilterValues(filterValuesObj);
    }
    else {
      const filterValuesObj: any = Object.assign({}, filterValues);
      delete filterValuesObj[name]
      await setFilterValues(filterValuesObj);
    }
  }

  const inputChange = async (name: string, value: string) => {
    const fieldsValues: any = Object.assign({}, fields);
    fieldsValues[name] = value;
    await setFields(fieldsValues);
  };

  const fetchFilteredContent = async () => {
    setFetchLoading(true);
    await dispatch(DashboardActions(`/users?size=${size}&page=${page}${filterValues.status && fields.status !== '' ? `&status=${fields.status}` : ''}${filterValues.username && fields.username !== '' ? `&username=${fields.username}` : ''}${filterValues.dateRange && range ? `&createdDateFrom=${dayjs(range.from).format("YYYY-MM-DD HH:mm:ss")}` : ''}${filterValues.dateRange && range ? `&createdDateTo=${dayjs(range.to).format("YYYY-MM-DD HH:mm:ss")}` : ''}`));
    setFetchLoading(false);
    setSelectedMenu(false);
  }

  return (
    <>
      {renderFetchLoading()}
      {renderAddUserModal()}
      <UsersTemplateStyle>
        <div className={`container-full settings`}>
          <div className={`container-full settings__desc`}>
            <HeaderText value="Settings" />
          </div>
          <SettingsNavBar />
          <div className={`container-full settings__content`}>
            <div className={`container-full settings__content__desc`}>
              <HeaderText value='All Users' />
            </div>
            <div className={`container-full settings__content__action`}>
              <Input className={`input`} type="text" value={search} placeholder="Search record"
                onChange={(event) => setSearch(event.target.value)}
                onKeyPress={event => {
                  if (event.key === 'Enter' || event.which === 13 || event.keyCode === 13) {
                    generatePageContent();
                  }
                }}
              />
              <div className='btn-group'>
                {
                  (state.exportReducer.results.data.length > 0) ?
                    <CSVLink data={exportData().fileData()} headers={exportData().fileHeaders()} filename={"users.csv"}>
                      <button className='button --export'>
                        <Image image={exportIcon} />
                      </button>
                    </CSVLink> :
                    <CSVLink data={exportDataAll().fileData()} headers={exportDataAll().fileHeaders()} filename={"users.csv"}>
                      <button className='button --export'>
                        <Image image={exportIcon} />
                      </button>
                    </CSVLink>
                }
                <button className={`button --user ${state.authReducer.results.roles.includes('Administrator') ? '' : '--disabled'}`} onClick={() => showAddUserModal()}>
                  <Image image={userIcon} />
                </button>
              </div>
            </div>
            <div className={`container-full settings__content__filter`}>
              <div className={`settings__content__filter__item --filter`}>
                <div className={`--filter__box`}>
                  <Image image={filterIcon} alt="filter-icon" />
                </div>
                <Text value='Filter' />
              </div>
              {/* <div className={`settings__content__filter__item --active-filter`}>
                  <Text value='No active filters' />
                </div> */}
              <div className={`settings__content__filter__item --add-filter`} onBlur={() => onBlurHandler()} onFocus={() => onFocusHandler()}>
                <button className={`button --elipses`} onClick={() => onClickHandler(true)} aria-haspopup="true" aria-expanded={selectedMenu}>
                  <Image image={plus} />
                  <Text value='Add filter' />
                </button>
                {
                  selectedMenu !== false && (
                    <button className='unset'>
                      <div className={`container-full more-info`}>
                        <div className={`container-full more-info__top`}>
                          <div className={`div-md-4 more-info__top__item`}>
                            <div className={`container-full more-info__top__item__desc`}>
                              <div className={`more-info__top__item__desc__checkbox`}>
                                <input
                                  type="checkbox"
                                  name="dateRange"
                                  onChange={(event) => changeFilterValue(event, event.target.name, event.target.value)}
                                  defaultChecked={(filterValues.dateRange) ? true : false}
                                />
                                <Image image={nike} />
                              </div>
                              <Text value='Date Range' />
                            </div>
                            <div className={`container-full more-info__top__item__input`}>
                              <Input type="text" className={`input ${(filterValues.dateRange === undefined) ? 'disabled' : null
                                }`}
                                placeholder="Select Date Range"
                                value={(range) ? `${dayjs(range.from).format("YYYY-MM-DD")} to ${dayjs(range.to).format("YYYY-MM-DD")}` : ''}
                                name="dateRange"
                                onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                                readOnly
                              />
                              {
                                (filterValues.dateRange) ?
                                  <DayPicker
                                    mode="range"
                                    defaultMonth={pastMonth}
                                    selected={range}
                                    footer={footer}
                                    modifiersStyles={{
                                      selected: {
                                        background: 'blue',
                                        color: 'white',
                                        fontWeight: 'bold',
                                      },
                                    }}
                                    onSelect={setRange}
                                    style={{ position: "absolute", left: "0", marginTop: "40px", background: "white", boxSizing: "border-box", padding: "35px", boxShadow: "0px 15px 44px rgba(10, 18, 73, 0.15)" }}
                                    styles={{
                                      day: { boxSizing: "border-box", padding: '10px', borderRadius: "8px", fontFamily: "Mulish", },
                                      caption: { fontFamily: "Mulish" },
                                    }}
                                  /> : null
                              }
                            </div>
                          </div>
                          <div className={`div-md-4 more-info__top__item`}>
                            <div className={`container-full more-info__top__item__desc`}>
                              <div className={`more-info__top__item__desc__checkbox`}>
                                <input
                                  type="checkbox"
                                  name="username"
                                  onChange={(event) => changeFilterValue(event, event.target.name, event.target.value)}
                                  defaultChecked={(filterValues.username) ? true : false}
                                />
                                <Image image={nike} />
                              </div>
                              <Text value='Username' />
                            </div>
                            <div className={`container-full more-info__top__item__input`}>
                              <Input type="text"
                                className={`input ${(filterValues.username === undefined) ? 'disabled' : null
                                  }`}
                                placeholder="Enter username"
                                name="username"
                                value={fields.username}
                                onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                              />
                            </div>
                          </div>
                          <div className={`div-md-4 more-info__top__item`}>
                            <div className={`container-full more-info__top__item__desc`}>
                              <div className={`more-info__top__item__desc__checkbox`}>
                                <input
                                  type="checkbox"
                                  name="status"
                                  onChange={(event) => changeFilterValue(event, event.target.name, event.target.value)}
                                  defaultChecked={(filterValues.status) ? true : false}
                                />
                                <Image image={nike} />
                              </div>
                              <Text value='User Status' />
                            </div>
                            <div className={`container-full more-info__top__item__input`}>
                              <div className='input'>
                                <select required
                                  className={
                                    `${(filterValues.status === undefined) ? 'disabled' : null}`
                                  }
                                  name="status"
                                  value={fields.status}
                                  onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                                >
                                  <option value="" hidden> Select User Status </option>
                                  <option value="1"> Active </option>
                                  <option value="0"> Disabled </option>
                                  <option value="2"> Pending </option>
                                  <option value="3"> Pending update enabled </option>
                                  <option value="4"> Pending update disabled </option>
                                  <option value="5"> Rejected pending </option>
                                </select>
                                <Image image={caret} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={`container-full more-info__bottom`}>
                          <Button value="Cancel" className='button --cancel' onClick={() => setSelectedMenu(false)} />
                          <Button value="Apply Filters" className={`button --apply`} onClick={() => fetchFilteredContent()} />
                        </div>
                      </div>
                    </button>
                  )
                }
              </div>
            </div>
          </div>
          <div className='container-full settings__table'>
            {
              (state.dashboardReducer.results !== null) ?
                <UsersTable data={state.dashboardReducer.results} pagination={size} setPagination={changeSize} changePage={changePage} page={page} reloadPage={refreshTable} /> : null
            }
          </div>
        </div>
      </UsersTemplateStyle>
    </>
  );
};

export default UsersTemplate;
